<template>
    <div>
        <v-rect :config="config" @click="onClick" ref="arcFaceFour"></v-rect>
    </div>

</template>

<script>
export default {
    name: "faceFour",
    props:['config', 'teeth','apliedFill'],
    methods : {
        onClick(){
            if (this.config.fill === "transparent") {
                this.config.fill = "red";
                this.$emit('selected', {
                    faceCode: 'F4',
                    dentNumber: this.teeth.number
                });
            } else if (this.config.fill === "red") {
                this.config.fill = "transparent";
                this.$emit('deselected', {
                    faceCode: 'F4',
                    dentNumber: this.teeth.number
                });
            }

            console.log(this.$refs.arcFaceFour._props.config)
        }
    },
    computed: {
        faceFill() {
            if (this.apliedFill.length > 0) {
                return 'red';
            } else {
                return 'transparent';
            }
        }
    },
    watch: {
        faceFill: {
            handler(newValue) {
                this.config.fill = newValue;
            },
            immediate: true
        }
    }
};
</script>
